module.exports = __webpack_public_path__ + "img/orange_082.c77b6935.png";